export default{
    computed:{
        hide(){
            const route = ['reset-password', 'desconectar'];
            const {name} = this.$route;
            return route.includes(name);
          },
    }
}